module.exports = __webpack_public_path__ + "static/media/si.ae21a5d9.svg";